"use strict";
/**
 * Created by rouven on 13.06.17.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var wizardActions_1 = require("../actions/wizardActions");
var Wizard = /** @class */ (function (_super) {
    __extends(Wizard, _super);
    function Wizard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Wizard.prototype.componentDidMount = function () {
        this.props.initialize();
    };
    Wizard.prototype.componentWillUnmount = function () {
        this.props.destroy();
    };
    Wizard.prototype.render = function () {
        return react_1["default"].createElement("div", null, this.props.activeStep);
    };
    return Wizard;
}(react_1.Component));
var mapState = function (_a, _b) {
    var wizard = _a.wizard;
    var name = _b.name, children = _b.children;
    return ({
        activeStep: react_1["default"].Children
            .map(children, function (Child) {
            return wizard[name] && wizard[name].step === Child.props.step
                ? react_1["default"].cloneElement(Child, { wizard: name })
                : null;
        })
            .filter(function (el) { return el !== null; })
    });
};
var mapDispatch = function (dispatch, _a) {
    var name = _a.name;
    return ({
        initialize: function () { return dispatch((0, wizardActions_1.initializeWizard)(name)); },
        destroy: function () { return dispatch((0, wizardActions_1.destroyWizard)(name)); }
    });
};
// @ts-ignore
var WizardContainer = (0, react_redux_1.connect)(mapState, mapDispatch)(Wizard);
exports["default"] = WizardContainer;
